import { render, staticRenderFns } from "./GoalSetting.vue?vue&type=template&id=5a40723c&scoped=true&lang=pug&"
import script from "./GoalSetting.vue?vue&type=script&lang=ts&"
export * from "./GoalSetting.vue?vue&type=script&lang=ts&"
import style0 from "./GoalSetting.vue?vue&type=style&index=0&id=5a40723c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a40723c",
  null
  
)

export default component.exports